import { HubConnectionBuilder } from '@microsoft/signalr';
import { useContext, useEffect, useRef, useState } from 'react';
import './notificationStyle.scss';
import { useHistory } from 'react-router-dom';
import AppContext from '../AppContext';
import { AppStorage } from '../../Core/Service/storage-service';

let config = window._ENV_;
let _serverNotification = '';

if (process.env.NODE_ENV === 'production') {
    _serverNotification = config.backendUrl.prod;
} else {
    _serverNotification = 'https://localhost:44367';
    _serverNotification = config.backendUrl.dev;
}

const NotificationListner = () => {
    const history = useHistory();
    const { showToast, userRoles } = useContext(AppContext);
    const isCustomer = userRoles.includes('customer');
    const isInternal = userRoles.includes('internal');
    const isTechnician = userRoles.includes('technician');
    const [state, setState] = useState({
        notifications: []
    });

    const connectionRef = useRef(null);

    useEffect(() => {
        const connectToNotificationHub = async () => {
            const connection = new HubConnectionBuilder()
                .withUrl(`${_serverNotification}/notificationHub`, {
                    accessTokenFactory: () => {
                        // return your auth token if required
                        return AppStorage.getToken();
                    }
                })
                .withAutomaticReconnect()
                .build();

            connection.on('ReceiveNotification', (message) => {
                console.log('Received notification:', message);
                setState((prevState) => ({
                    notifications: [...prevState.notifications, message]
                }));
            });

            try {
                await connection.start();
                console.log('SignalR connection established');
                connectionRef.current = connection;
            } catch (error) {
                console.error('SignalR connection error:', error);
            }
        };
        connectToNotificationHub();
        return () => {
            connectionRef.current?.stop();
        };
    }, []);

    const dismissNotification = (id) => {
        setState((prev) => ({ ...prev, notifications: prev.notifications.filter((n) => n.id !== id) }));
    };

    const handleRedirectToJobDetails = (data) => {
        if (isInternal) {
            history.push(`/Job/${data.headerRecordID}/${data.workflowID}?ProcessId=${data.processID}`);
        } else if (isTechnician) {
            history.push(`/Job/${data.headerRecordID}/${data.technicianJobId ? data.technicianJobId : data.workflowID}?ProcessId=${data.processID}`);
        } else {
            // history.push(`/Job/${data.headerRecordID}/${data.workflowID}?ProcessId=${data.processID}`);
            return false;
        }
    };

    return (
        <div class="notificationContainer">
            {state.notifications.map((n) => (
                <div key={n.id} class="notificationBox">
                    <span onClick={() => handleRedirectToJobDetails(n)}>{n.message}</span>
                    <button class="closeButton" onClick={() => dismissNotification(n.id)}>
                        ✖
                    </button>
                </div>
            ))}
        </div>
    );
};

export default NotificationListner;
